
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/context/AuthContext";

interface ChatStatus {
  totalMessages: number;
  unreadMessages: number;
  hasMessages: boolean;
}

export const useNotificationChatStatus = (notificationId: string) => {
  const { user } = useAuth();
  
  const { data, isLoading } = useQuery({
    queryKey: ['notification-chat-status', notificationId, user?.id],
    queryFn: async (): Promise<ChatStatus> => {
      // Default status with no messages - notification_chat table does not exist yet
      // This prevents console errors and allows the rest of the app to work
      const defaultStatus: ChatStatus = {
        totalMessages: 0,
        unreadMessages: 0,
        hasMessages: false
      };
      
      return defaultStatus;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes cache
    refetchInterval: false, // Use real-time instead of polling
    refetchOnWindowFocus: false, // No refetch on focus
  });
  
  return {
    ...data,
    isLoading
  };
};
